


















































import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';

interface Consignment {
  central_billing: {
    date: string;
    lifts: number;
    pallets: number;
  };
  reporting?: {
    date: string;
    lifts: number;
    pallets: number;
  };
}

export default Vue.extend({
  name: 'CentralBillingComparison',
  data() {
    return {
      showMatching: false,
      consignments: {} as { [trackingId: string]: Consignment },
    };
  },
  methods: {
    async processCentralBilling(event: InputEvent) {
      const fileInput = event.target as HTMLInputElement;
      const centralBillingFile = fileInput.files?.item(0);
      if (!centralBillingFile) {
        return;
      }
      const payload = new FormData();
      payload.set('central_billing', centralBillingFile, centralBillingFile.name);
      const response = await axios.post<{ [trackingId: string]: Consignment }>(
          `${BASE_URL}/reports/central-billing/`, payload);
      this.consignments = response.data;
    },
    diff(consignment: Consignment) {
      const fields: Array<keyof Consignment['central_billing'] & keyof NonNullable<Consignment['reporting']>> = [
        'date',
        'lifts',
        'pallets',
      ];
      return !consignment.reporting || fields.some((f) => consignment.central_billing[f] !== consignment.reporting![f]);
    },
  },
});
